/**
 * 投遞數據簡要報表（訂單層級，Excel / Word）的資料內容欄位。值就是送給後端的 metrics 字串，
 * 後端以 enum 常數名逐字比對（大小寫敏感、沒有別名），所以值本身是契約。
 */
export enum DeliveryBriefMetric {
  CPC = 'CPC',
  CPM = 'CPM',
  CPV = 'CPV',
  CPA = 'CPA',
  IMPRESS = 'IMPRESS',
  VIEW = 'VIEW',
  CLICK = 'CLICK',
  CONVS = 'CONVS',
  VIEW_RATE = 'VIEW_RATE',
  CTR = 'CTR'
}

export enum DeliveryBriefFormat {
  EXCEL = 'EXCEL',
  WORD = 'WORD'
}

export const DELIVERY_BRIEF_FILE_EXTENSION: {
  [format in DeliveryBriefFormat]: string;
} = {
  [DeliveryBriefFormat.EXCEL]: 'xlsx',
  [DeliveryBriefFormat.WORD]: 'docx'
};
